import React, { useEffect } from 'react'
import { Divider } from '@material-ui/core'

import ItemEcommerce from '~/components/Ecommerce/ItemEcommerce'
import { useDataEcommerce } from './useDataEcommerce'
import track from '~/track'

function storeHadSeen(store) {
  track('lojaOnlineListada', {
    category: 'LojasOnline',
    name: store?.name
  })
}

export default function ListEcommerce({
  configEcommerce,
  dataEcommerce,
  openEcommerce,
  handleLogger
}) {
  const {
    hasStoresFeatured,
    hasStoresManuals,
    isViewLimited,
    isViewOnlyStoresManuals,
    isViewOnlyStoresFeatured,
    showProductValue,
    storesManuals,
    dataOffersFeatured,
    filteredOffers
  } = useDataEcommerce(dataEcommerce, configEcommerce)

  useEffect(() => {
    if (!isViewLimited || (isViewOnlyStoresManuals && isViewOnlyStoresFeatured)) {
      hasStoresManuals && storesManuals.map(storeHadSeen)
      hasStoresFeatured && dataOffersFeatured.map(storeHadSeen)
    } else {
      isViewOnlyStoresManuals && hasStoresManuals && storesManuals.map(storeHadSeen)
      isViewOnlyStoresFeatured && hasStoresFeatured && dataOffersFeatured.map(storeHadSeen)
    }

    !isViewLimited && filteredOffers?.map(storeHadSeen)
  }, [])

  return (
    <>
      {!isViewLimited || (isViewOnlyStoresManuals && isViewOnlyStoresFeatured) ? (
        <>
          {hasStoresFeatured && (
            <>
              {dataOffersFeatured?.map((store, index, arr) => (
                <ItemEcommerce
                  key={`${store.name}-${index}`}
                  store={store}
                  product={openEcommerce}
                  showValue={showProductValue}
                  handleLogger={handleLogger}
                  divider={index !== arr.length - 1}
                  configEcommerce={configEcommerce}
                />
              ))}

              {hasStoresManuals && (
                <Divider
                  variant="middle"
                  component="li"
                  style={{ backgroundColor: '#EEE', listStyleType: 'none' }}
                />
              )}
            </>
          )}

          {hasStoresManuals &&
            storesManuals
              .filter((store) =>
                hasStoresFeatured
                  ? !dataOffersFeatured.some(
                      (dof) => dof?.name?.toLowerCase() === store.name.toLowerCase()
                    )
                  : true
              )
              .map((store, index, arr) => (
                <ItemEcommerce
                  isManually
                  key={`${store.name}-${index}`}
                  store={store}
                  product={openEcommerce}
                  handleLogger={handleLogger}
                  divider={index !== arr.length - 1}
                  configEcommerce={configEcommerce}
                />
              ))}
        </>
      ) : (
        <>
          {isViewOnlyStoresManuals &&
            hasStoresManuals &&
            storesManuals.map((store, index, arr) => (
              <ItemEcommerce
                key={`${store.name}-${index}`}
                store={store}
                product={openEcommerce}
                handleLogger={handleLogger}
                divider={index !== arr.length - 1}
                isManually
              />
            ))}

          {isViewOnlyStoresFeatured &&
            hasStoresFeatured &&
            dataOffersFeatured.map((store, index, arr) => (
              <ItemEcommerce
                key={`${store.name}-${index}`}
                store={store}
                product={openEcommerce}
                showValue={showProductValue}
                handleLogger={handleLogger}
                divider={index !== arr.length - 1}
              />
            ))}
        </>
      )}

      {!isViewLimited && (
        <>
          {(hasStoresFeatured || hasStoresManuals) && (
            <Divider variant="middle" component="li" style={{ backgroundColor: '#EEE' }} />
          )}

          {filteredOffers?.map((store, index, arr) => (
            <ItemEcommerce
              key={`${store.name}-${index}`}
              store={store}
              product={openEcommerce}
              showValue={showProductValue}
              handleLogger={handleLogger}
              divider={index !== arr.length - 1}
            />
          ))}
        </>
      )}
    </>
  )
}
